import React, { useState } from "react";
import "../common/common.css";
import "./loginLanding.css";
import { useSearchParams, useNavigate } from "react-router-dom";
import { authApiEndpoint } from "../../utils/env";

const RESET_ENDPOINT = authApiEndpoint("/api/ApplicationUser/ResetPassword");

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get("uid") || "";
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!userId || !token) {
      setError("Reset link is invalid or expired.");
      return;
    }
    if (!password) {
      setError("New password is required.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(RESET_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, token, newPassword: password }),
      });
      let body = null;
      try {
        body = await res.json();
      } catch {
        body = null;
      }
      if (!res.ok) {
        const msg = body?.message || "Unable to reset password";
        throw new Error(msg);
      }

      setMessage("Your password has been reset. You can now sign in.");
      setTimeout(() => navigate("/login", { replace: true }), 2000);
    } catch (err) {
      setError(err.message || "Unable to reset password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="landing-root">
      <div className="landing-hero">
        <div className="hero-top">
          <div className="brand">
            <img
              src="/brand-logo.svg"
              alt="DIXI Vault"
              className="brand-logo"
            />
            <span className="brand-name">DIXI Vault</span>
          </div>
        </div>

        <div className="hero-content">
          <div className="hero-copy">
            <div className="eyebrow">Choose a new password</div>
            <h1>Reset password</h1>
            <p>Set a new password for your DIXI Vault account.</p>
          </div>
          <div className="hero-art">
            <img src="/illustration-hero.svg" alt="Reset password" />
          </div>
        </div>
      </div>

      <aside className="auth-panel" aria-label="Reset password">
        <form onSubmit={onSubmit} className="auth-card">
          <div className="chip">Password reset</div>
          <label className="f-label">
            New password
            <input
              className="f-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </label>
          <label className="f-label">
            Confirm password
            <input
              className="f-input"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </label>
          {error && (
            <div className="error-text" role="alert">
              {error}
            </div>
          )}
          {message && !error && (
            <div className="success-text" role="status">
              {message}
            </div>
          )}
          <button className="cta submit" disabled={submitting} type="submit">
            {submitting ? "Updating…" : "Update password"}
          </button>
          <div className="small-links">
            <a href="/login">Back to sign in</a>
          </div>
        </form>
      </aside>
    </div>
  );
}
